import React from 'react';
import { Link } from 'react-router-dom';
import { FiGrid, FiLink, FiBookOpen, FiFile } from 'react-icons/fi';

const categories = [

  {
    path: '/knowledge/utilities',
    title: 'Utilities',
    description: 'TDS charts, tax slabs, depreciation rates, and cost inflation indices.',
    icon: FiGrid
  },
  {
    path: '/knowledge/links',
    title: 'Links',
    description: 'Quick link directory and reference list for tax & corporate sites.',
    icon: FiLink
  },
  {
    path: '/knowledge/acts',
    title: 'Acts',
    description: 'Direct Tax, Indirect Tax, Corporate, and GST statutes.',
    icon: FiBookOpen
  },
  {
    path: '/knowledge/rules',
    title: 'Rules',
    description: 'Direct Tax, Indirect Tax, Corporate, and GST rules.',
    icon: FiFile
  }
];

export default function KnowledgeBank() {
  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <h1>Knowledge <span>Bank</span></h1>
        <p>Access comprehensive statutes and corporate resources</p>
      </div>

      <main style={{ padding: '60px 0', background: 'var(--off-white)' }}>
        <div className="container">
          <div 
            style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', 
              gap: '24px',
              paddingTop: '20px'
            }}
          >
            {categories.map(({ path, title, description, icon: Icon }) => (
              <Link 
                key={title} 
                to={path} 
                style={{ 
                  background: 'var(--white)',
                  border: '1px solid var(--gray-200)',
                  borderRadius: 'var(--radius-md)',
                  padding: '32px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  transition: 'all var(--transition)',
                  cursor: 'pointer'
                }}
                className="kb-card"
              >
                <div 
                  style={{ 
                    width: '56px',
                    height: '56px',
                    borderRadius: '50%',
                    background: 'rgba(25, 135, 84, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--primary)'
                  }}
                >
                  <Icon size={24} />
                </div>
                <div>
                  <h3 
                    style={{ 
                      fontSize: '1.35rem', 
                      color: 'var(--primary-dark)', 
                      marginBottom: '8px',
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 700 
                    }}
                  >
                    {title}
                  </h3>
                  <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: '1.5' }}>
                    {description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
